import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  uri: "https://services-prod-gateway.apnaklub.com/graphql",
  cache: new InMemoryCache(),
});
